import { CountUp } from './../../../node_modules/countup.js/dist/countUp.min.js';

document.addEventListener("DOMContentLoaded", () => {

    const elements = document.querySelectorAll('.anim');

    const handleCountUp = (element) => {
        const countUpElement = element.querySelector('.countup');

        const options = {
          separator: '',
        };
        
        if (countUpElement) {
            console.log('Found count up element');
            const targetNumber = countUpElement.innerHtml;
            const countUp = new CountUp(countUpElement, targetNumber, options);
            countUp.start();
        }
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) return;

            const target = entry.target;

            // Find nearest anim-group (not only direct parent)
            const group = target.closest('.anim-group');

            if (group) {
                const siblings = Array.from(group.querySelectorAll('.anim'));
                const index = siblings.indexOf(target);

                const baseDelay = index * 180;
                const randomOffset = Math.floor(Math.random() * 60) - 30;
                const finalDelay = Math.max(0, baseDelay + randomOffset);

                setTimeout(() => {
                    target.classList.add('is-inview');
                    handleCountUp(target);
                }, finalDelay);

            } else {
                target.classList.add('is-inview');
                handleCountUp(target);
            }

            observer.unobserve(target);
        });
    }, {
        threshold: 0.2
    });

    elements.forEach(el => observer.observe(el));
});
